export const ADMIN_BANNERS_REQUEST = "ADMIN_BANNERS_REQUEST";
export const ADMIN_BANNERS_SUCCESS = "ADMIN_BANNERS_SUCCESS";
export const ADMIN_BANNERS_FAIL = "ADMIN_BANNERS_FAIL";

export const NEW_BANNER_REQUEST = "NEW_BANNER_REQUEST";
export const NEW_BANNER_SUCCESS = "NEW_BANNER_SUCCESS";
export const NEW_BANNER_RESET = "NEW_BANNER_RESET";
export const NEW_BANNER_FAIL = "NEW_BANNER_FAIL";

export const DELETE_BANNER_REQUEST = "DELETE_BANNER_REQUEST";
export const DELETE_BANNER_SUCCESS = "DELETE_BANNER_SUCCESS";
export const DELETE_BANNER_RESET = "DELETE_BANNER_RESET";
export const DELETE_BANNER_FAIL = "DELETE_BANNER_FAIL";

export const ALL_BANNERS_REQUEST = "ALL_BANNERS_REQUEST";
export const ALL_BANNERS_SUCCESS = "ALL_BANNERS_SUCCESS";
export const ALL_BANNERS_FAIL = "ALL_BANNERS_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";